// src/pages/DeliveryStatus/components/DeliveryActionModal.jsx
import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import PinInput from "react-pin-input";
import {
  acceptDocumentsForDelivery,
  sendDeliveryCodeToClient,
  completeDelivery,
  forceCompleteDelivery,
} from "../utils/fetch";

export function AcceptDocumentsForDeliveryButton({ lead, refresh }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  if (!lead.isHasDelivery) return null;

  const handleAccept = async () => {
    setLoading(true);
    try {
      await acceptDocumentsForDelivery(lead._id);
      refresh();
    } catch (e) {
      message.error(e?.response?.data?.message || "Ошибка при принятии");
    } finally {
      setLoading(false);
      setVisible(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setVisible(true)} loading={loading}>
        Принять
      </Button>
      <Modal
        title="Принятие документов"
        visible={visible}
        onOk={handleAccept}
        onCancel={() => setVisible(false)}
        okText="Принять"
        cancelText="Отмена"
        confirmLoading={loading}
      >
        <p>Убедитесь, что переданный заказ соответствует Акту приема-передачи.</p>
      </Modal>
    </>
  );
}

export function CompleteDeliveryButton({ lead, refresh }) {
  const [codeModal, setCodeModal] = useState(false);
  const [forceModal, setForceModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState("");
  if (!lead.isHasDelivery) return null;

  const requestCode = async () => {
    setLoading(true);
    try {
      await sendDeliveryCodeToClient(lead._id, lead.client[0].phone);
      setCodeModal(true);
    } catch (e) {
      message.error(e?.response?.data?.message || "Ошибка при отправке кода");
    } finally {
      setLoading(false);
    }
  };

  const handleComplete = async () => {
    setLoading(true);
    try {
      await completeDelivery(pin, lead);
      message.success("Доставка завершена");
      refresh();
    } catch (e) {
      message.error("Неверный код");
    } finally {
      setLoading(false);
      setCodeModal(false);
    }
  };

  const handleForce = async () => {
    setLoading(true);
    try {
      await forceCompleteDelivery(lead._id);
      refresh();
    } catch (e) {
      message.error(e.message || "Ошибка при принудительном завершении");
    } finally {
      setLoading(false);
      setForceModal(false);
    }
  };

  return (
    <>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <Button onClick={requestCode} loading={loading}>
          Завершить доставку
        </Button>
        <Button danger onClick={() => setForceModal(true)} loading={loading}>
          Принудительно
        </Button>
      </div>

      <Modal
        title="Введите код для завершения"
        visible={codeModal}
        onOk={handleComplete}
        onCancel={() => setCodeModal(false)}
        okText="Отправить"
        cancelText="Отмена"
        confirmLoading={loading}
      >
        <PinInput
          length={4}
          onChange={(val) => setPin(val)}
          type="numeric"
        />
      </Modal>

      <Modal
        title="Принудительное завершение"
        visible={forceModal}
        onOk={handleForce}
        onCancel={() => setForceModal(false)}
        okText="Да, завершить"
        cancelText="Отмена"
        confirmLoading={loading}
      >
        <p>Вы уверены?</p>
      </Modal>
    </>
  );
}
